<template>
    <div class="foot">
        <div class="f_content">
            <div class="f_c_top">
                <div class="f_c_t_log">
                    <img src="../../assets/images/logo.png" width="102"  alt="">
                </div>
                <div class="f_c_t_uls">
                    <ul>
                        <li>
                            <router-link to="/">首页</router-link>
                        </li>
                        <li>
                            <router-link to="/steward">环保管家服务</router-link>
                        </li>
                        <li>
                            <router-link to="/company">公司介绍</router-link>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <router-link to="/information">信息公开</router-link>
                        </li>
                        <li>
                            <router-link to="/legislation">法律法规</router-link>
                        </li>
                        <li>
                            <router-link to="/project">工程案例</router-link>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <router-link to="/contact">联系我们</router-link>
                        </li>
                        <li>
                            咨询：{{ companyObj.fphone }}
                        </li>
                        <li>
                            邮箱：{{ companyObj.femail }}
                        </li>
                        <li>
                            地址：{{ companyObj.faddress }}
                        </li>
                    </ul>
                </div>
            </div>

            <div class="f_c_bottom">

                <p>
                   &copy; 2018 义乌皓景环境技术有限公司 All Right Reserved <a style="color: #999" href="http://beian.miit.gov.cn/" target="_blank">浙ICP备18034296号-1</a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from '../../assets/js/baseaxios'
    export default {
        name: "foot",
        data(){
            return{
                companyObj:{}
            }
        },
        mounted() {
            this.getData()
        },
        methods:{
            getData(){
                axios.get(`/api/company`).then(res=>{
                    if(res.data.success){
                        let items = res.data.items[0]
                        this.companyObj = items

                    }else{
                        this.$message.warning(res.data.msg)
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .foot{
        position: relative;
        width: 100%;
        height: 303px;
        background-color: #373D44;
    }
    .foot:after{
        content: '';
        position: absolute;
        bottom: 60px;
        height: 1px;
        left: 0;
        right: 0;
        background-color: #999;
    }
    .f_content{
        width: 1100px;
        height: 100%;
        margin:0 auto;
    }
    .f_c_top{
        height: 243px;
    }
    .f_c_t_log{
        float: left;
        margin-top: 41px;
        margin-right: 112px;
    }
    .f_c_t_uls{
        float: left;
        margin-top: 41px;
    }
    .f_c_t_uls ul{
        float: left;
        width: 280px;
    }
    .f_c_t_uls ul:last-child{
        width: 326px;
    }
    .f_c_t_uls ul li{
        line-height: 39px;
        font-size: 14px;
        color: #999;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .f_c_t_uls ul li a{
        color: #fff;
    }
    .f_c_bottom{
        height: 60px;
    }
    .f_c_bottom p{
        color: #999;
        font-size: 14px;
        text-align: center;
        line-height: 60px;
    }
</style>
